import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { ApiService } from '../../core/api.service';

@Component({
  selector: 'app-restaurants',
  standalone: true,
  imports: [CommonModule, FormsModule, QRCodeModule],
  templateUrl: './restaurants.component.html',
  styleUrl: './restaurants.component.css'
})
export class RestaurantsComponent implements OnInit {
  restaurants: any[] = [];

  editingRestaurantId: number | null = null;

  loading = false;
  loadingRestaurants = false;
  error = '';
  success = '';

  form: any = this.createEmptyForm();

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.load();
  }

  createEmptyForm() {
    return {
      name: '',
      slug: '',
      whatsapp: '',
      description: '',
      address: '',
      deliveryFee: 0,
      minimumOrder: 0,
      logoUrl: '',
      coverUrl: '',
      isOpen: true
    };
  }

  load(): void {
    this.loadingRestaurants = true;
    this.error = '';

    this.api.get<any[]>('/restaurants').subscribe({
      next: (restaurants) => {
        this.restaurants = restaurants;
        this.loadingRestaurants = false;
      },
      error: (error) => {
        this.loadingRestaurants = false;
        this.error =
          error?.error?.message ||
          'Erro ao carregar restaurantes.';
      }
    });
  }

  save(): void {
    this.error = '';
    this.success = '';

    if (!this.form.name?.trim()) {
      this.error = 'Informe o nome do restaurante.';
      return;
    }

    if (!this.form.whatsapp?.trim()) {
      this.error = 'Informe o WhatsApp do restaurante.';
      return;
    }

    const payload = {
      name: this.form.name.trim(),
      slug: this.form.slug?.trim() || undefined,
      whatsapp: String(this.form.whatsapp).replace(/\D/g, ''),
      description: this.form.description?.trim() || null,
      address: this.form.address?.trim() || null,
      deliveryFee: Number(this.form.deliveryFee || 0),
      minimumOrder: Number(this.form.minimumOrder || 0),
      logoUrl: this.form.logoUrl?.trim() || null,
      coverUrl: this.form.coverUrl?.trim() || null,
      isOpen: Boolean(this.form.isOpen)
    };

    this.loading = true;

    if (this.editingRestaurantId !== null) {
      this.updateRestaurant(payload);
      return;
    }

    this.createRestaurant(payload);
  }

  createRestaurant(payload: any): void {
    this.api.post<any>('/restaurants', payload).subscribe({
      next: () => {
        this.loading = false;
        this.success = 'Restaurante criado com sucesso.';
        this.resetForm();
        this.load();
      },
      error: (error) => {
        this.loading = false;
        this.error =
          error?.error?.message ||
          'Erro ao criar restaurante.';
      }
    });
  }

  updateRestaurant(payload: any): void {
    this.api
      .put<any>(`/restaurants/${this.editingRestaurantId}`, payload)
      .subscribe({
        next: () => {
          this.loading = false;
          this.success = 'Restaurante atualizado com sucesso.';
          this.resetForm();
          this.load();
        },
        error: (error) => {
          this.loading = false;
          this.error =
            error?.error?.message ||
            'Erro ao atualizar restaurante.';
        }
      });
  }

  editRestaurant(restaurant: any): void {
    this.error = '';
    this.success = '';
    this.editingRestaurantId = restaurant.id;

    this.form = {
      name: restaurant.name || '',
      slug: restaurant.slug || '',
      whatsapp: restaurant.whatsapp || '',
      description: restaurant.description || '',
      address: restaurant.address || '',
      deliveryFee: Number(restaurant.deliveryFee || 0),
      minimumOrder: Number(restaurant.minimumOrder || 0),
      logoUrl: restaurant.logoUrl || '',
      coverUrl: restaurant.coverUrl || '',
      isOpen: restaurant.isOpen !== false
    };

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  cancelEdit(): void {
    this.resetForm();
  }

  resetForm(): void {
    this.editingRestaurantId = null;
    this.form = this.createEmptyForm();
    this.error = '';
  }

  publicLink(restaurant: any): string {
    return `${location.origin}/cardapio/${restaurant.slug}`;
  }

  getImageUrl(imageUrl: string): string {
    if (!imageUrl) {
      return '';
    }

    if (imageUrl.startsWith('http')) {
      return imageUrl;
    }

    return `http://localhost:3000${imageUrl}`;
  }

  formatMoney(value: any): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number(value || 0));
  }
}